import { useEffect, useRef, useState } from 'react';

import { useSelector } from 'react-redux';

import { eventBus } from '@atc/cai-event-bus';

import {
    UDS_PAYMENT_OBJ_UPDATE,
} from 'wallet-manager';

import paymentsDuck from '@/ducks/paymentsDuck.js';

const usePaymentData = (supportedDealTypes) => {
    const [hasError, setHasError] = useState(false);
    const [localPayments, setLocalPayments] = useState(null);
    const [paymentsData, setPaymentsData] = useState(null);
    const paymentsRef = useRef(localPayments);

    const isLoading = useSelector(paymentsDuck.selectors.getIsLoading);

    // setting error on timeout
    useEffect(() => {
        const timeoutId = setTimeout(() => {
            if (paymentsRef.current && Object.keys(paymentsRef.current).length === 0) {
                setHasError(true);
            }
        }, 5000);

        return () => clearTimeout(timeoutId);
    }, []);

    const handlePaymentObjectUpdate = (paymentObj) => {
        setLocalPayments(paymentObj);
    };

    useEffect(() => {
        eventBus.on(
            UDS_PAYMENT_OBJ_UPDATE,
            handlePaymentObjectUpdate
        );

        return () => {
            eventBus.off(
                UDS_PAYMENT_OBJ_UPDATE,
                handlePaymentObjectUpdate
            );
        };
    }, []);

    useEffect(() => {
        // update ref to current value for timeout
        paymentsRef.current = localPayments;
        setPaymentsData(localPayments);

    }, [localPayments, supportedDealTypes]);

    return [isLoading, hasError, paymentsData];
};

export default usePaymentData;
